
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal",
      function () {
        return require("private-next-pages/journal/index.jsx");
      }
    ]);
  